import { useLazyQuery }                                      from '@apollo/client'
import { ArrowUturnLeftIcon }                                from '@heroicons/react/24/solid'
import { useEffect }                                         from 'react'
import { useDispatch, useSelector }                          from 'react-redux'
import { useNavigate }                                       from 'react-router-dom'
import { Button }                                            from '../../../components'
import { LoadingEllipsis }                                   from '../../../components/Loaders'
import { setDeliveryOptionsRefetch, setShopDeliveryOptions } from '../../../features/shop/shopSlice'
import { GET_SHOP_DELIVERY_OPTIONS }                         from '../../../graphql/shop'
import MainLayout                                            from '../../../layouts/MainLayout'

export default function SettingsShopDeliveryOptionsList(): JSX.Element {
  const navigate: any               = useNavigate()
  const dispatch: any               = useDispatch()
  const currentUser: any            = useSelector( ( state: any ): any => state.currentUser.user )
  const deliveryOptions: any        = useSelector( ( state: any ): any => state.shop.deliveryOptions )
  const deliveryOptionsRefetch: any = useSelector( ( state: any ): any => state.shop.deliveryOptionsRefetch )

  const [ getDeliveryOptions, { loading, refetch } ] = useLazyQuery( GET_SHOP_DELIVERY_OPTIONS, {
    notifyOnNetworkStatusChange: true,
    onCompleted:                 ( { shopDeliveryOptions }: any ): void => dispatch( setShopDeliveryOptions( shopDeliveryOptions ) )
  } )

  const fetchDeliveryOptions: any = async (): Promise<void> => {
    await getDeliveryOptions()
  }

  const refetchDeliveryOptions: any = async (): Promise<void> => {
    await refetch()
    dispatch( setDeliveryOptionsRefetch( false ) )
  }

  useEffect( (): any => {
    let shouldFetch: boolean = true

    if ( shouldFetch && !deliveryOptions?.length ) {
      fetchDeliveryOptions()
    }

    if ( deliveryOptionsRefetch ) {
      refetchDeliveryOptions()
    }

    return (): void => {
      shouldFetch = false
    }
  }, [ deliveryOptions ] )

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { !currentUser && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4 w-full" /> }
          { currentUser?.admin &&
            <>
              <div className="flex justify-between w-full my-4">
                <div className="flex">
                  <Button
                    label="Back"
                    blue
                    onClick={ (): any => navigate( -1 ) }
                    icon={ <ArrowUturnLeftIcon className="w-4 h-4" /> }
                  />
                </div>
                <div className="flex space-x-4">
                  <Button label="Add new delivery" yellow onClick={ (): any => navigate( '/settings/shop/delivery-options/add' ) } />
                </div>
              </div>

              { ( loading ) && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4" /> }

              { !loading &&
                <>
                  { deliveryOptions?.map( ( deliveryOption: any, index: any ): any =>
                                            <div className="flex items-center justify-between w-full bg-white rounded-3xl p-3 xl:p-4" key={ index }>
                                              <div>{ deliveryOption.name }</div>

                                              <div className="flex flex-wrap items-center">
                                                <Button label="Edit" yellow onClick={ (): any => navigate( `/settings/shop/delivery-options/edit/${ deliveryOption.id }` ) } />
                                              </div>
                                            </div> ) }
                </>
              }
            </>
          }
          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
